// extracted by mini-css-extract-plugin
module.exports = {"MobileSidebarOverlay":"Main_MobileSidebarOverlay__HzXsX","DemoModeBanner":"Main_DemoModeBanner__2iEO2"};